import { render, staticRenderFns } from "./GdPictureOcrServiceSettings.vue?vue&type=template&id=438b2735&"
import script from "./GdPictureOcrServiceSettings.vue?vue&type=script&lang=ts&"
export * from "./GdPictureOcrServiceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports